/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUserByCPF = /* GraphQL */ `
  query userByCpf(
    $cpf: String
  ) {
    userByCpf(
      cpf: $cpf
    ) {
      items {
        id
        nome
        cpf
        email
        metadata
        whatsapp
        photo_url
        createdAt
        updatedAt
      }
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      nome
      cpf
      email
      whatsapp
      metadata
      photo_url
      createdAt
      updatedAt
    }
  }
`;
